import { createCryptoBalanceSelector } from 'components/features/rewards/rewardsPane/store/selectors/cryptoWallet'
import { cryptoCurrenciesMarketSelector, cryptoCurrenciesMetaSelector } from 'components/features/rewards/rewardsPane/store/selectors/currencies'
import { CurrencyTicker } from 'components/features/rewards/rewardsPane/types/apiResponses'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { useMemo } from 'react'
import { getAmountCrypto, getBalanceUsd, getMinimalAmountUsd } from 'components/features/rewards/rewardPage/helpers'
import { getItemFromCollection } from 'helpers/normalizeHelpers'


export const useBalance = (ticker: CurrencyTicker) => {
  const cryptoBalanceSelector = useMemo(createCryptoBalanceSelector, [])
  const item = useStoreSelector((state) => cryptoBalanceSelector(state, ticker) ?? null)

  return useMemo(() => {
    if (item === null) {
      return null
    }
    const { price, balance_crypto } = item
    if (price === null || balance_crypto === null) {
      return null
    }

    const result = getBalanceUsd(price, balance_crypto)

    return result
  }, [item])
}

export const useMinBuyCryptoAmount = (ticker: CurrencyTicker | null) => {
  const market = useStoreSelector(cryptoCurrenciesMarketSelector)
  const price = useMemo(() => {
    return getItemFromCollection(market, ticker)?.price ?? null
  }, [ticker, market])


  const meta = useStoreSelector(cryptoCurrenciesMetaSelector)
  const minAmount = useMemo(() => {
    if (ticker === null) {
      return null
    }

    return meta?.byKey[ticker].minAmount ?? null
  }, [ticker, meta])

  return useMemo(() => {
    if (price === null || minAmount === null) {
      return '0'
    }

    return getMinimalAmountUsd(minAmount, price)
  }, [minAmount, price])
}

export const useMinSellCryptoAmount = (ticker: CurrencyTicker | null) => {
  const cryptoBalanceSelector = useMemo(createCryptoBalanceSelector, [])
  const price = useStoreSelector((state) => ticker ? cryptoBalanceSelector(state, ticker)?.price ?? null : null)

  const meta = useStoreSelector(cryptoCurrenciesMetaSelector)
  const minAmount = useMemo(() => {
    if (ticker === null) {
      return null
    }

    return meta?.byKey[ticker].minAmount ?? null
  }, [ticker, meta])

  return useMemo(() => {
    if (price === null || minAmount === null) {
      return '0'
    }

    return getMinimalAmountUsd(minAmount, price)
  }, [minAmount, price])
}

export const useSellAmountCrypto = (amountUsd: number, ticker: CurrencyTicker) => {
  const cryptoBalanceSelector = useMemo(createCryptoBalanceSelector, [])
  const item = useStoreSelector((state) => ticker ? cryptoBalanceSelector(state, ticker) ?? null : null)

  return useMemo(() => {
    if (item === null) {
      return null
    }

    return getAmountCrypto(amountUsd, item.balance_crypto, item.price)
  }, [amountUsd, item])
}
